import React from "react";

/** Renders a single chat line in terminal-style, with a blinking caret while streaming. */
export default function ChatMessage({ message, isStreaming, testid }) {
  const isUser = message.role === "user";
  const label = isUser ? "user>" : "hub>";
  const labelColor = isUser ? "text-[#FF5722]" : "text-[#10B981]";
  const textColor = isUser ? "text-white" : "text-zinc-300";

  return (
    <div data-testid={testid}>
      <div className="flex gap-3">
        <span className={`${labelColor} shrink-0`}>{label}</span>
        <span className={`${textColor} whitespace-pre-wrap`}>
          {message.content}
          {isStreaming && !isUser && (
            <span className="inline-block w-2 h-4 bg-[#FF5722] align-middle ml-1 blink" />
          )}
        </span>
      </div>
    </div>
  );
}
